
import { Drop, Auction, Raffle } from '../types';
import { clubRepository } from '../../data/clubRepository';
import { logger } from '../../infrastructure/logger';

export const clubService = {
    
    // --- DROPS ---
    async saveDrop(dropData: Partial<Drop>): Promise<{ success: boolean; message: string; data?: Drop }> {
        if (!dropData.title || !dropData.price) return { success: false, message: 'Datos incompletos' };

        const drop: Drop = {
            id: dropData.id || `d-${Date.now()}`,
            title: dropData.title,
            productName: dropData.productName || '',
            imageUrl: dropData.imageUrl || '',
            price: Number(dropData.price),
            startsAt: dropData.startsAt || new Date().toISOString(),
            stock: Number(dropData.stock) || 1,
            isActive: dropData.isActive ?? false,
            productId: dropData.productId
        };

        // Always use addDrop (setDoc) to support Upsert with pre-generated IDs
        await clubRepository.addDrop(drop);

        return { success: true, message: 'Drop guardado', data: drop };
    },

    async deleteDrop(id: string): Promise<boolean> {
        await clubRepository.deleteDrop(id);
        return true;
    },

    async toggleDropStatus(drop: Drop): Promise<boolean> {
        await clubRepository.updateDrop({ ...drop, isActive: !drop.isActive });
        return !drop.isActive;
    },

    // --- AUCTIONS (Includes Bidding Logic) ---
    async saveAuction(auctionData: Partial<Auction>): Promise<{ success: boolean; message: string; data?: Auction }> {
        if (!auctionData.title || !auctionData.basePrice) return { success: false, message: 'Datos incompletos' };

        const auction: Auction = {
            id: auctionData.id || `a-${Date.now()}`,
            title: auctionData.title,
            productName: auctionData.productName || '',
            imageUrl: auctionData.imageUrl || '',
            basePrice: Number(auctionData.basePrice),
            currentBid: Number(auctionData.currentBid) || Number(auctionData.basePrice),
            highestBidder: auctionData.highestBidder || 'Nadie',
            endsAt: auctionData.endsAt || new Date().toISOString(),
            isActive: auctionData.isActive ?? false,
            status: auctionData.status || 'active',
            productId: auctionData.productId,
            bids: auctionData.bids || [],
            winner: auctionData.winner
        };

        // Always use addAuction (setDoc) to support Upsert
        await clubRepository.addAuction(auction);

        return { success: true, message: 'Subasta guardada', data: auction };
    },

    async deleteAuction(id: string): Promise<boolean> {
        await clubRepository.deleteAuction(id);
        return true;
    },

    async closeAuction(id: string): Promise<void> {
        await clubRepository.closeAuction(id);
    },

    /**
     * Places a bid atomically using a Firestore Transaction.
     */
    async placeBid(auctionId: string, amount: number, user: { id: string; name: string }): Promise<{ success: boolean; message?: string }> {
        try {
            const result = await clubRepository.placeBid(auctionId, amount, user.name);
            return result;

        } catch (error) {
            logger.error('[ClubService] Bidding Error', error);
            return { success: false, message: 'Error de conexión al pujar' };
        }
    },

    // --- RAFFLES ---
    async updateRaffle(raffle: Partial<Raffle>): Promise<void> {
        await clubRepository.updateRaffle(raffle);
    }
};
